import { Avatar, MenuItemProps, useRuntimeEnv, useRuntimeEnvRolesIncludes, useTranslationLang, useTranslationRoute, useTranslations, useUserProfilePicture } from "@bsm/component";
import { useMemo } from "react";

export const useLeftSideBarMenuParameters = () => {

    const [
        PARAMETERS,
        ORGANISATIONS,
        USERS,
        LOGOUT,
        ARTICLE
    ] = useTranslations(i18n)
    const translationRoute = useTranslationRoute();
    const { lang } = useTranslationLang()

    const { runtimeEnv } = useRuntimeEnv();

    const roleIncludes = useRuntimeEnvRolesIncludes(true);
    const canManageOrganisation = roleIncludes("ORGANISATION")
    const profilePictureUrl = useUserProfilePicture()

    const organisation: MenuItemProps | undefined = useMemo(
        () => {
            if (!canManageOrganisation) {
                return undefined;
            }
            return ({
                label: runtimeEnv?.organisation?.designation,
                link: translationRoute(
                    `admin/user/organisation/${runtimeEnv.organisation?.id}/about`
                ),
                startIcon: "fa-solid fa-building"
            })
        },
        [runtimeEnv, lang]
    );

    return useMemo(() => ({
        ke: "parameters",
        label: PARAMETERS,
        className: "menu-item-category",
        items: [
            {
                label: runtimeEnv?.personnel?.fullName,
                startIcon: (
                    <Avatar
                        size="xs"
                        src={profilePictureUrl(runtimeEnv?.personnel?.id)}
                        fullName={runtimeEnv?.personnel?.fullName}
                    />
                ),
                link: translationRoute(
                    `admin/user/${runtimeEnv?.personnel?.id}/about`
                ),
                isConnected: true,
                className: "username-menu",
            },
            organisation,
            {
                label: LOGOUT,
                startIcon: "fa-solid fa-right-to-bracket",
                link: translationRoute("logout"),
            },
        ],
    }), [lang])
}

const i18n = [
    'BSMRH.Admin.LeftSideBar.Menu.Parameters.Label',
    'BSMRH.Admin.LeftSideBar.Menu.Parameters.Organisations.Label',
    'BSMRH.Admin.LeftSideBar.Menu.Parameters.Users.Label',
    'BSMRH.Admin.LeftSideBar.Menu.Parameters.Logout.Label',
    'BSMRH.Admin.LeftSideBar.Menu.Parameters.Article.Label',
]
